import { render, staticRenderFns } from "./MalattieInfettiveConfigurazioneUosdListComponent.vue?vue&type=template&id=cd7f19d6"
import script from "./MalattieInfettiveConfigurazioneUosdListComponent.vue?vue&type=script&lang=js"
export * from "./MalattieInfettiveConfigurazioneUosdListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports